import { OnDestroy, Renderer2, RendererFactory2 } from "@angular/core";
import { fromEventPattern, Subject } from "rxjs";
import { takeUntilDestroy } from "take-until-destroy";
import * as i0 from "@angular/core";
/**
 ****************************************************************
 * Service class for catching window events.
 *
 * Created by Shai Zelman on 08/07/2020.
 ****************************************************************
 */
var WindowEventsService = /** @class */ (function () {
    function WindowEventsService(rendererFactory2) {
        this.rendererFactory2 = rendererFactory2;
        this.scrollSubject = new Subject();
        var renderer = this.rendererFactory2.createRenderer(null, null);
        this.createOnClickObservable(renderer);
        this.createOnScrollObservable();
    }
    Object.defineProperty(WindowEventsService.prototype, "onScroll", {
        get: function () {
            return this.scrollSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    WindowEventsService.prototype.ngOnDestroy = function () {
    };
    WindowEventsService.prototype.createOnClickObservable = function (renderer) {
        var removeClickEventListener;
        var createClickEventListener = function (handler) {
            removeClickEventListener = renderer.listen("document", "click", handler);
        };
        this.onClick = fromEventPattern(createClickEventListener, function () { return removeClickEventListener(); }).pipe(takeUntilDestroy(this));
    };
    WindowEventsService.prototype.createOnScrollObservable = function () {
        var _this = this;
        document.addEventListener('scroll', function (e) {
            _this.scrollSubject.next(e);
        }, true);
    };
    WindowEventsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WindowEventsService_Factory() { return new WindowEventsService(i0.ɵɵinject(i0.RendererFactory2)); }, token: WindowEventsService, providedIn: "root" });
    return WindowEventsService;
}());
export { WindowEventsService };
